import { create } from "zustand";

// the purpose of this store is to store amount selected from hero section slider
// also it will determine amount has been updated from hero section slider or not
const useLoanAmountStore = create((set) => ({
  selectedLoanAmount: 300000,
  isAmountSelectedFromHero: false,
  updateSelectedLoanAmount: (newSelectedLoanAmount) =>
    set({ selectedLoanAmount: newSelectedLoanAmount, isAmountSelectedFromHero: true }),
  resetAmountSelectedFromHero: () => set({ isAmountSelectedFromHero: false })
}));

export default useLoanAmountStore;
